import { render, staticRenderFns } from "./WeekView.vue?vue&type=template&id=4446d617"
import script from "./WeekView.ts?vue&type=script&lang=ts&external"
export * from "./WeekView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports